import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Card,
    CardBody,
} from 'reactstrap';
import {
    API_SpaceStandalonePage_Integration,
    gAPI_Ingetration,
    gAPI_Property_List_By_Group,
    API_Ingetration,
    dAPI_Delete_Ingetration,
} from '../../../../constants/APIs';
import IntlMessages from '../../../../helpers/IntlMessages';
import { NavLink } from 'react-router-dom';
import meetingroom_logo from './../../../../assets/meeting-room.png';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette, faBorderAll, faFont, faLanguage } from '@fortawesome/free-solid-svg-icons';
import SpaceStandaloneDigitalAssistant from '../integration/components/SpaceStandalone/SpaceStandaloneDigitalAssistant';
import AddSpaceStandAlonePageIntegration from '../integration/components/SpaceStandalone/AddSpaceStandalonePageIntegration';
import IntegrationInfo from '../integration/components/IntegrationInfo';
import SpaceStandaloneFonts from '../integration/components/SpaceStandalone/SpaceStandaloneFonts';
import SpaceStandAloneCodeSnippet from '../integration/components/SpaceStandalone/SpaceStandaloneCodeSnippet';
import CustomEmails from '../integration/components/SpaceStandalone/CustomEmail';
import Example from '../integration/components/Example';
import { Colxx, Separator } from '../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import SpaceSettings from '../integration/components/SpaceStandalone/SpaceSettings';
import SpaceStandAloneLayout from '../integration/components/SpaceStandalone/SpaceStandaloneLayout';
import Validation from '../../../../components/Validation';
function Settings({ match, history, propertyId, propertyData }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const integrationId = match.params.id;
    const [isAddStandalonePage, setIsAddStandalonePage] = useState(false);
    const [fontsVisible, setFontsVisible] = useState(false);
    let [integration, setIntegration] = useState();
    const [allProperties, setAllProperties] = useState([]);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [propertyVisible, setPropertyVisible] = useState(true);
    const [SpaceStandAloneLayoutVisible, setSpaceStandAloneLayoutVisible] = useState(false);
    const [nudgesVisible, setNudgesVisible] = useState(false);
    const [positionVisible, setPositionVisible] = useState(false);
    const [languageVisible, setLanguageVisible] = useState(false);
    const [apperanceVisible, setApperanceVisible] = useState(false);
    const [publishVisible, setPublishVisible] = useState(false);
    const [emailVisible, setEmailVisible] = useState(false);
    const [showConnect, setShowConnect] = useState(false);
    const [settings, setSettings] = useState(false);
    const [isSpaceStandalonePage, setIsSpaceStandAlonePage] = useState(false);
    const localeOptions = [
        { id: "en", name: "English", desc: "English", code: "en", locale: "en" },
        { id: "hi", name: "Hindi", desc: "हिंदी", code: "hi", locale: "hi" },
        {
            id: "id",
            name: "Indonesian",
            desc: "bahasa Indonesia",
            code: "id",
            locale: "id",
        },
        { id: "es", name: "Spanish", desc: "Español", code: "es", locale: "es" },
        { id: "fr", name: "French", desc: "français", code: "fr", locale: "fr" },
        { id: "de", name: "German", desc: "Deutsche", code: "de", locale: "de" },
        { id: "zh", name: "Chinese", desc: "简体中文", code: "ZH-簡", locale: "zh" },
        {
            id: "vi",
            name: "Vietnamese",
            desc: "Tiếng Việt",
            code: "vi",
            locale: "vi",
        },
        { id: "th", name: "Thai", desc: "ไทย", code: "th", locale: "th" },
        { id: "ja", name: "Japanese", desc: "日本語", code: "ja", locale: "ja" },
        {
            id: "zh-TW",
            name: "Chinese (Traditional)",
            desc: "繁體中文",
            code: "ZH-繁",
            locale: "hk",
        },
        {
            id: "tl",
            name: "Tagalog (Filipino)",
            desc: "Tagalog (Filipino)",
            code: "tl",
            locale: "tl",
        },
        { id: "af", name: "Afrikaans", desc: "Afrikaans", code: "af", locale: "af" },
        { id: "ko", name: "Korean", desc: "한국어", code: "ko", locale: "ko" },
        { id: "mi", name: "Maori", desc: "Maori", code: "mi", locale: "mi" },
    ];
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };

    const property = () => {
        setPropertyVisible(true);
        setSpaceStandAloneLayoutVisible(false);
        setFontsVisible(false);
        setEmailVisible(false);
        setPublishVisible(false);
        setApperanceVisible(false);
        setSettings(false);
    };
    const layout = () => {
        setPropertyVisible(false);
        setFontsVisible(false);
        setSpaceStandAloneLayoutVisible(true);
        setEmailVisible(false);
        setPublishVisible(false);
        setSettings(false);
        setApperanceVisible(false);
    };

    useEffect(() => {
        let body = {
            channels: ['SpaceStandalone']
        }
        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body
        }).then((res) => {
            const spaceStandAloneIntegrationData = res.data.filter(
                (k) => k.channel === 'SpaceStandalone' && k.properties.includes(propertyId)
            );
            console.log(spaceStandAloneIntegrationData);
            if (spaceStandAloneIntegrationData.length > 0)
                setIntegration(spaceStandAloneIntegrationData[0]);
            else
                setShowConnect(true);
        })
            .catch((err) => { console.log(err) });

        AxiosAPI({
            method: 'get',
            url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        }).then((res) => {
            setAllProperties(res.data);
        });
    }, []);

    const handleCustomEmails = (email) => {
        integration.StandalonePage.pageSettings.voucherEmail.email = email;
    };

    const saveIntegration = (data) => {
        if (data.list === undefined)
            integration.StandalonePage = data;
        if (data.list !== undefined) {
            integration.properties = data.list;
            integration.name = data.name;
            integration.ismembership = data.isShowMembership;
            integration.MembershipTags = data.selectedMemberShipTags.map((m) => m.value);
        }

        if (data.isaivaHide !== undefined)
            integration.isaivaHide = data.isaivaHide;
        AxiosAPI({
            method: 'put',
            url: `${API_SpaceStandalonePage_Integration}/${integration.id
                }?group_id=${getGroupID()}`,
            data: integration,
        })
            .catch((err) => console.error(err))
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            }
            );
    };

    const RedirectToDemo = () => {
        var url = `${process.env.REACT_APP_WEBVIEW
            }/spaces?gid=${getGroupID()}&iid=${integration.id}`;
        window.open(url, '_blank');
    };

    const publishCode = () => {
        setPropertyVisible(false);
        setSpaceStandAloneLayoutVisible(false);
        setFontsVisible(false);
        setNudgesVisible(false);
        setPositionVisible(false);
        setEmailVisible(false);
        setPublishVisible(true);
        setApperanceVisible(false);
        setSettings(false);
    };


    const appearance = () => {
        setPropertyVisible(false);
        setSpaceStandAloneLayoutVisible(false);
        setFontsVisible(false);
        setEmailVisible(false);
        setPublishVisible(false);
        setApperanceVisible(true);
        setSettings(false);
    };
    const emails = () => {
        setPropertyVisible(false);
        setSpaceStandAloneLayoutVisible(false);
        setFontsVisible(false);
        setEmailVisible(true);
        setPublishVisible(false);
        setApperanceVisible(false);
        setSettings(false);
    };
    const setFonts = () => {
        setPropertyVisible(false);
        setApperanceVisible(false);
        setNudgesVisible(false);
        setEmailVisible(false);
        setFontsVisible(true);
        setPositionVisible(false);
        setPublishVisible(false);
        setSettings(false);
    };

    const setSpaceSetting = () => {
        setPropertyVisible(false);
        setApperanceVisible(false);
        setNudgesVisible(false);
        setEmailVisible(false);
        setFontsVisible(false);
        setSettings(true);
        setPositionVisible(false);
        setPublishVisible(false);
    };



    const generateDeleteButton = () => {
        return (
            <Row>
                {isSpaceStandalonePage ? (
                    <Row>
                        <Colxx xxs="12">
                            <Row>
                                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                                <Colxx md="4" sm="4" lg="4" xxs="12">
                                    <AddSpaceStandAlonePageIntegration
                                        visible={isSpaceStandalonePage}
                                        propertyId={propertyId}
                                        toggle={() => {
                                            setIsAddStandalonePage(!isSpaceStandalonePage);
                                        }}
                                        allProperties={allProperties}
                                    />
                                </Colxx>
                                <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                            </Row>
                        </Colxx>
                    </Row>
                ) : null}

                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This integration will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    /** FIXME: */
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
        })
            .then((res) => console.log('res', res))
            .then(
                setTimeout(() => {
                    window.location.reload()
                }, 300)
            );
    };

    console.log(showConnect);
    return (
        <Fragment>
            <Fragment>
                <Row>
                    <Colxx xxs="12" md="6" className="mb-4">
                        <Card>
                            <CardBody>
                                <Fragment>
                                    {showConnect === true ?
                                        <Colxx md="12" className="mb-3">
                                            <Card
                                                className="d-flex flex-row integrationcard"
                                                style={{ height: '215px' }}
                                                onClick={() => setIsSpaceStandAlonePage(!isSpaceStandalonePage)}
                                            >
                                                <div className="position-relative">
                                                    <h3 className="integrationChannel">
                                                        <img
                                                            src={meetingroom_logo}
                                                            alt="Logo"
                                                            style={{ maxWidth: '50px' }}
                                                        />
                                                    </h3>
                                                </div>
                                                <CardBody>
                                                    <Row>
                                                        <Colxx xxs="12" className="mb-5 mt-5">
                                                            <div className="text-center">
                                                                <div className="mb-1">
                                                                    <h1 className="iconsminds-add" />
                                                                </div>
                                                                <h2>Create Space Booking Engine</h2>
                                                            </div>
                                                        </Colxx>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Colxx> :
                                        <Fragment>
                                            {integration !== undefined &&
                                                <Fragment>
                                                    <div
                                                        className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <div className={`glyph-icon iconsminds-hotel`} />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => property()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        <IntlMessages id='integration.select_properties' />
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        <IntlMessages id='integration.select_properties_enabled' />
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>
                                                        <Separator />
                                                    </div>
                                                    <div
                                                        className={`mb-3 integration ${SpaceStandAloneLayoutVisible ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <div className={`glyph-icon iconsminds-building`} />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => layout()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        Select Space Standalone Layout
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        Select the layout that are visible through this
                                                                        integration
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>

                                                        <Separator />
                                                    </div>
                                                    <div
                                                        className={`mb-3 integration ${apperanceVisible ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <FontAwesomeIcon icon={faPalette} className="fa" />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => appearance()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        <IntlMessages id='integration.appearance' />
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        Choose your space widget name, avatar and
                                                                        setup your colours
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>
                                                        <Separator />
                                                    </div>
                                                    <div
                                                        className={`mb-3 integration  ${emailVisible ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <div className={`glyph-icon iconsminds-mail-2`} />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => emails()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        Custom Emails
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        Create a custom emails for the space widget
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>
                                                        <Separator />
                                                    </div>
                                                    <div
                                                        className={`mb-3 integration  ${settings ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <div className={`glyph-icon iconsminds-gear`} />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => setSpaceSetting()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        Booking Confirmation Settings
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        Control the workflows your way
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>
                                                        <Separator />
                                                    </div>
                                                    <div
                                                        className={`mb-3 integration ${fontsVisible == true ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <FontAwesomeIcon icon={faFont} className="fa" />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => setFonts()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        Custom Fonts
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        Control the fonts of space widget on your website
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>
                                                        <Separator />
                                                    </div>

                                                    <div
                                                        className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                                                            }`}
                                                    >
                                                        <div className="glyph">
                                                            <div
                                                                className={`glyph-icon iconsminds-monitor---tablet`}
                                                            />
                                                        </div>
                                                        <NavLink
                                                            to="#"
                                                            className="w-40 w-sm-100"
                                                            onClick={(e) => publishCode()}
                                                        >
                                                            <Row>
                                                                <Colxx xxs="12" md="10">
                                                                    <p className="list-item-heading mb-1 color-theme-1">
                                                                        SEO Settings & Booking URL
                                                                    </p>
                                                                    <p className="mb-4 text-small">
                                                                        Copy the url to view or share your space
                                                                        widget
                                                                    </p>
                                                                </Colxx>
                                                                <Colxx xxs="12" md="2">
                                                                    <div className="glyph">
                                                                        <div
                                                                            className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                                        />
                                                                    </div>
                                                                </Colxx>
                                                            </Row>
                                                        </NavLink>
                                                        <Separator />
                                                    </div>
                                                    <div>
                                                        <Button
                                                            color="dark"
                                                            style={{
                                                                width: '100%',
                                                                borderRadius: '6px',
                                                            }}
                                                            className="mb-4"
                                                            onClick={RedirectToDemo}
                                                        >
                                                            Preview
                                                        </Button>

                                                        <Separator />
                                                    </div>
                                                    <div>
                                                        <Button
                                                            color="dark"
                                                            outline
                                                            style={{
                                                                width: '100%',
                                                                borderRadius: '6px',
                                                            }}
                                                            className="mb-4"
                                                            onClick={toggle}
                                                        >
                                                            Archive
                                                        </Button>

                                                        <Separator />
                                                    </div>
                                                </Fragment>}
                                        </Fragment>
                                    }
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Colxx>
                    <Colxx xxs="12" md="6" className="mb-4">
                        {emailVisible && (
                            <Fragment>
                                <CustomEmails
                                    handleCustomEmails={handleCustomEmails}
                                    integration={integration}
                                    integrationProperties={integration.spaceStandalonePageIntegration.pageSettings}
                                    allProperties={allProperties}
                                    saveIntegration={saveIntegration}
                                    botSettings={integration.spaceStandalonePageIntegration.pageSettings}
                                />
                                <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" />

                            </Fragment>
                        )}
                        {apperanceVisible && (
                            <Fragment>
                                <SpaceStandaloneDigitalAssistant
                                    integration={integration}
                                    botSettings={integration.spaceStandalonePageIntegration.pageSettings}
                                    saveIntegration={saveIntegration}
                                    integrationId={integration.id}
                                    allProperties={allProperties}
                                    propertyId={propertyId}
                                />
                                <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" />
                            </Fragment>
                        )}
                        {settings && (
                            <Fragment>
                                <SpaceSettings
                                    integration={integration.spaceStandalonePageIntegration.pageSettings}
                                    saveIntegration={saveIntegration}
                                    integrationId={integration.id}
                                    allProperties={allProperties}
                                    propertyId={propertyId}
                                />
                                <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" />
                            </Fragment>
                        )}
                        {integration !== undefined && propertyVisible && (
                            <Fragment>
                                <IntegrationInfo
                                    integration={integration}
                                    integrationProperties={integration.properties}
                                    allProperties={allProperties}
                                    saveIntegration={saveIntegration}
                                />
                                <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" />
                            </Fragment>
                        )}
                        {fontsVisible && (
                            <Fragment>
                                <SpaceStandaloneFonts
                                    botSettings={integration.spaceStandalonePageIntegration.pageSettings}
                                    integrationProperties={integration.properties}
                                    allProperties={allProperties}
                                    saveIntegration={saveIntegration}
                                />
                                <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" />
                            </Fragment>
                        )}
                        {publishVisible && <SpaceStandAloneCodeSnippet propertyId={propertyId} integration={integration} saveIntegration={saveIntegration} />}
                        {SpaceStandAloneLayoutVisible && (
                            <Fragment>
                                <SpaceStandAloneLayout
                                    pageSettings={integration.spaceStandalonePageIntegration.pageSettings}
                                    saveIntegration={saveIntegration}
                                    integrationId={integration.id}
                                />
                                <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" />
                            </Fragment>
                        )}
                    </Colxx>
                </Row>
            </Fragment>
            {generateDeleteButton()}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment >
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, propertyData } = settings;
    return {
        propertyId, propertyData
    };
};

export default injectIntl(connect(mapStateToProps, {})(Settings));
